import { fromJson } from '@bufbuild/protobuf';
import type { TeamCandidateEntity, TeamCandidateRemovedEntity } from '@platform/timeline';
import { TeamMemberAddedSchema } from '../pb/proto/sem/team/team_selection_pb';
import { registerSem } from '../registry';

registerSem('team.member.added', ({ ev, now, convId }) => {
  const d = fromJson(TeamMemberAddedSchema, (ev.data || {}) as any);
  const m = d.data;
  if (!m?.personId || !m?.name) return null;
  const id = `team-candidate-${m.personId}`;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id,
      kind: 'team_candidate',
      timestamp: now,
      props: (() => {
        const p: any = {
          name: m.name,
          person_id: m.personId,
        };
        if (typeof m.email === 'string' && m.email.trim() !== '') p.email = m.email;
        if (typeof m.role === 'string' && m.role.trim() !== '') p.role = m.role;
        if (typeof m.roleText === 'string' && m.roleText.trim() !== '') p.role_text = m.roleText;
        if (typeof m.score === 'number' && m.score > 0) p.score = m.score;
        return p as any;
      })(),
    } as TeamCandidateEntity,
  };
});

// Handle removals using plain JSON (no protobuf schema yet)
registerSem('team.member.removed', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const personId: string | undefined = d.person_id || d.personId;
  if (!personId) return null;
  const id = `team-candidate-removed-${personId}`;
  return {
    kind: 'add',
    convId,
    entity: {
      id,
      kind: 'team_candidate_removed',
      timestamp: now,
      props: {
        person_id: personId,
        email: d.email,
        reason: typeof d.reason === 'string' ? d.reason : undefined,
      },
    } as TeamCandidateRemovedEntity,
  };
});

// Handle validation failures by emitting a status/message entity
registerSem('team.member.failed', ({ ev, now, convId }) => {
  const d = (ev.data || {}) as any;
  const text = `Could not add ${d?.name || d?.email || 'team member'}: ${d?.reason || 'validation error'}`;
  return {
    kind: 'add',
    convId,
    entity: {
      id: `team-member-failed-${ev.id}`,
      kind: 'status',
      timestamp: now,
      props: {
        type: 'error',
        text,
        error_code: d?.error_code,
        email: d?.email,
        name: d?.name,
      },
    },
  };
});
